// extracted by mini-css-extract-plugin
module.exports = {"card":"TotalBalanceCard_card__2l-Yb"};